import {UPDATE_TOAST} from "./toastActionType";

export const updateToast = (payload) => ({ type: UPDATE_TOAST, payload })
